import { gql } from "@apollo/client";

export const GET_PROFESIONAL_BY_ID = gql`
    query GetProfesionalDetalleById($idProfesional: Int!) {
        profesionalDetalle(idProfesional: $idProfesional) {
            idProfesional
            nombre
            apellido
            activo
            sexo
            idFuncion
            idTipoProfesional
            idTipoDocumento
            idEspecialidad
            idCalificacion
            idClaseMonitoreo
            cod_SAP
            numeroDoc
            email
            cUIT
            cuitSAP
            fechaNac
            estadoAPP
            observacion
            fechaProximoMonitoreo
            fidelizado
            t_DatoContactoProfesional {
                calle
                numero
                piso
                unidad
                idLocalidad
                latitud
                longitud
                cP
                idLocalidadNavigation {
                    idProvincia
                    descripcion
                    idProvinciaNavigation {
                        idPais
                        descripcion
                        idPaisNavigation {
                            pais
                        }
                    }
                }
                observaciones
                telefonoParticular
                telefonoMovil
                telefonoLaboral
            }

            tituloHabilitante
            matricula
            matriculaNac
            fechaVtoMatriculaNac
            matriculaProv
            fechaVtoMatriculaProv
            certificadoVacunacion
            observacionVacunacion
            curriculum
            firmoContrato
            posgradoEspecifico
            observacionPosgradoEspecifico
            experienciaEspecifica
            observacionExperienciaEspecifica
            profesionalZona
            observacionProfesionalZona
            seguroMalaPraxis
            idCalificacionNavigation{
                descripcion
            }
            idClaseMonitoreoNavigation{
                descripcion
            }
            profesionalMatricula {
                fechaVencimiento
                numero
                idOrigenMatriculaNavigation {
                    idOrigenMatricula
                    descripcion
                }
            }
            puntosClasificacion
            idDelegacionMonitoreo
            t_ProfesionalDel{
                idDelegacion
                activo
                idDelegacionNavigation {
                    descripcion
                }
            }
            gestionReclamoProfesional{
                idGestionReclamoNavigation{
                    idGestionReclamo
                    descripcion
                    fechaOcurrencia
                    fechaRegistro
                    idEstadoReclamo
                    numeroReclamo
                    correspondeProfesional
                    idEstadoReclamoNavigation{
                        descripcion
                    }
                    idUsuarioCreadorNavigation{
                        nombre
                        apellido
                    }
                }
            }
            ejerceFonoAudiologo
            ejerceKinesiologo
        }
    }
`;

export const adaptProfesionalDetalle = (profesional) => {
  const contactoData = profesional?.t_DatoContactoProfesional?.length > 1 ?
  structuredClone(profesional?.t_DatoContactoProfesional[profesional?.t_DatoContactoProfesional?.length - 1]) :
  profesional?.t_DatoContactoProfesional?.length == 1 ?
  structuredClone(profesional?.t_DatoContactoProfesional[0]) : {};

  return {
    datosMonitoreo: {
      posgradoEspecifico: profesional?.posgradoEspecifico,
      observacionPosgradoEspecifico: profesional?.observacionPosgradoEspecifico,
      experienciaEspecifica: profesional?.experienciaEspecifica,
      observacionExperienciaEspecifica: profesional?.observacionExperienciaEspecifica,
      profesionalZona: profesional?.profesionalZona,
      observacionProfesionalZona: profesional?.observacionProfesionalZona,
      puntosClasificacion: profesional?.puntosClasificacion,
      calificacionMonitoreo: profesional?.idCalificacionMonitoreoNavigation?.descripcion,
      fechaProximoMonitoreo: profesional?.fechaProximoMonitoreo
    },
    datosGenerales: {
      id: profesional?.idProfesional,
      nombreCompleto: `${profesional?.nombre} ${profesional?.apellido}`,
      nombre: profesional?.nombre,
      idFuncion: profesional?.idFuncion,
      apellido: profesional?.apellido,
      idTipoProfesional: profesional?.idTipoProfesional,
      idTipoDocumento: profesional?.idTipoDocumento,
      idEspecialidad: profesional?.idEspecialidad,
      codProfesional: profesional?.idProfesional,
      cod_Proveedor: profesional?.cod_SAP,
      activo: profesional?.activo,
      sexo: profesional?.sexo,
      numeroDoc: profesional?.numeroDoc,
      email: profesional?.email,
      fechaNacimiento: profesional?.fechaNac,
      cuitL: profesional?.cUIT,
      cuitSAP: profesional?.cuitSAP,
      observacion: profesional?.observacion,
      fidelizado: profesional?.fidelizado,
      ejerceFonoaudiologo: profesional?.ejerceFonoAudiologo,
      ejerceKinesiologo: profesional?.ejerceKinesiologo
    },
    datosContacto: {
      calle: contactoData?.calle,
      numero: contactoData?.numero,
      piso: contactoData?.piso,
      unidad: contactoData?.unidad,
      latitud: contactoData?.latitud,
      longitud: contactoData?.longitud,
      codigoPostal: contactoData?.cP,
      idLocalidad: contactoData?.idLocalidad,
      localidad: contactoData?.idLocalidadNavigation?.descripcion,
      idProvincia: contactoData?.idLocalidadNavigation?.idProvincia,
      provincia: contactoData?.idLocalidadNavigation?.idProvinciaNavigation?.descripcion,
      idPais: contactoData?.idLocalidadNavigation?.idProvinciaNavigation?.idPais,
      pais: contactoData?.idLocalidadNavigation?.idProvinciaNavigation?.idPaisNavigation.pais,
      observacion: contactoData?.observaciones,
      telefonoParticular: contactoData?.telefonoParticular,
      telefonoMovil: contactoData?.telefonoMovil,
      telefonoLaboral: contactoData?.telefonoLaboral
    },
    datosSeleccion: {
      matriculas: profesional?.profesionalMatricula?.map((matricula) => {
        return {
          idOrigenMatricula: matricula?.idOrigenMatriculaNavigation?.idOrigenMatricula,
          nombre: matricula?.idOrigenMatriculaNavigation?.descripcion,
          fechaVencimiento: matricula.fechaVencimiento,
          numero: matricula.numero
        };
      }) || [],
      observacionVacunacion: profesional?.observacionVacunacion,
      puntosClasificacion: profesional?.puntosClasificacion,
      idCalificacionMonitoreo: profesional?.idCalificacionMonitoreo,
      posgradoEspecifico: profesional?.posgradoEspecifico,
      observacionPosgradoEspecifico: profesional?.observacionPosgradoEspecifico,
      experienciaEspecifica: profesional?.experienciaEspecifica,
      observacionExperienciaEspecifica: profesional?.observacionExperienciaEspecifica,
      profesionalZona: profesional?.profesionalZona,
      observacionProfesionalZona: profesional?.observacionProfesionalZona
    },
    datosDelegaciones: {
      idDelegacionMonitoreo: profesional?.idDelegacionMonitoreo,
      delegaciones: profesional?.t_ProfesionalDel?.map((delegacion) => delegacion?.idDelegacion) || []
    }
  };
};